import { createContext, useContext } from 'react';
import type { ManagementQueryParams } from '../Management';

type ManagementPageContextType = {
  pageParams: ManagementQueryParams;
  setPageParams: React.Dispatch<React.SetStateAction<ManagementQueryParams>>;
};

export const ManagementPageContext = createContext(
  {} as ManagementPageContextType,
);

export const useManagementPageContext = () => useContext(ManagementPageContext);
